module.exports = __webpack_public_path__ + "static/img/body-bg.34db9f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/authorization/body-bg.png
// module id = EumS
// module chunks = 31